module.exports = __webpack_public_path__ + "img/eye.caa28914.svg";